import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRoleJobFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		roleId?: any;
		jobId?: any;
}

export class RoleJobFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public roleId: IEntityModelField = { name: "roleId", displayName: "Role Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public jobId: IEntityModelField = { name: "jobId", displayName: "Job Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.jobId);
	}
}

export class RoleJobDTO implements IEntityModel {
	protected roleJobName: string = "RoleJobModel";
	protected roleJobKeyField: string = "id";
	protected roleJobDisplayName: string = "Role Job|Role Jobs";
	protected roleJobFields = new RoleJobFields();
	public get name(): string { return this.roleJobName };
	public get keyField(): string { return this.roleJobKeyField };
	public get displayName(): string { return this.roleJobDisplayName };
	public get fields(): RoleJobFields { return this.roleJobFields };

	constructor() {};
}
